/* Holmden UX helpers */

/* Close the product image zoom popup when clicking outside it (on the dimmed backdrop).
   Uses the native dialog close: the theme component's animated close can stall, and the
   native close leaves no scroll-lock behind. */
document.addEventListener('click', function (e) {
  var t = e.target;
  if (!(t instanceof Element)) return;
  if (t.tagName !== 'DIALOG' || !t.classList.contains('dialog-zoomed-gallery__dialog')) return;
  var dlg = t;
  if (!dlg.open) return;
  var r = dlg.getBoundingClientRect();
  var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
  if (inside) return;
  dlg.close();
  document.documentElement.removeAttribute('scroll-lock');
});
